var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5992 1.5V8.3M17.9992 4.9H11.1992",
    stroke: "url(#paint0_linear_6573_1869)",
    strokeWidth: 1.32613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.9C1 3.70989 1 3.11483 1.23161 2.66027C1.43534 2.26043 1.76043 1.93534 2.16027 1.73161C2.61483 1.5 3.20989 1.5 4.4 1.5C5.59011 1.5 6.18517 1.5 6.63973 1.73161C7.03957 1.93534 7.36465 2.26043 7.56839 2.66027C7.8 3.11483 7.8 3.70989 7.8 4.9C7.8 6.09011 7.8 6.68517 7.56839 7.13973C7.36465 7.53957 7.03957 7.86465 6.63973 8.06839C6.18517 8.3 5.59011 8.3 4.4 8.3C3.20989 8.3 2.61483 8.3 2.16027 8.06839C1.76043 7.86465 1.43534 7.53957 1.23161 7.13973C1 6.68517 1 6.09011 1 4.9Z",
    stroke: "url(#paint1_linear_6573_1869)",
    strokeWidth: 1.32613
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.1002C1 13.9101 1 13.315 1.23161 12.8604C1.43534 12.4606 1.76043 12.1356 2.16027 11.9318C2.61483 11.7002 3.20989 11.7002 4.4 11.7002C5.59011 11.7002 6.18517 11.7002 6.63973 11.9318C7.03957 12.1356 7.36465 12.4606 7.56839 12.8604C7.8 13.315 7.8 13.9101 7.8 15.1002C7.8 16.2903 7.8 16.8854 7.56839 17.3399C7.36465 17.7398 7.03957 18.0648 6.63973 18.2686C6.18517 18.5002 5.59011 18.5002 4.4 18.5002C3.20989 18.5002 2.61483 18.5002 2.16027 18.2686C1.76043 18.0648 1.43534 17.7398 1.23161 17.3399C1 16.8854 1 16.2903 1 15.1002Z",
    stroke: "url(#paint2_linear_6573_1869)",
    strokeWidth: 1.32613
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1992 15.1002C11.1992 13.9101 11.1992 13.315 11.4308 12.8604C11.6346 12.4606 11.9596 12.1356 12.3595 11.9318C12.814 11.7002 13.4091 11.7002 14.5992 11.7002C15.7893 11.7002 16.3844 11.7002 16.839 11.9318C17.2388 12.1356 17.5638 12.4606 17.7676 12.8604C17.9992 13.315 17.9992 13.9101 17.9992 15.1002C17.9992 16.2903 17.9992 16.8854 17.7676 17.3399C17.5638 17.7398 17.2388 18.0648 16.839 18.2686C16.3844 18.5002 15.7893 18.5002 14.5992 18.5002C13.4091 18.5002 12.814 18.5002 12.3595 18.2686C11.9596 18.0648 11.6346 17.7398 11.4308 17.3399C11.1992 16.8854 11.1992 16.2903 11.1992 15.1002Z",
    stroke: "url(#paint3_linear_6573_1869)",
    strokeWidth: 1.32613
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6573_1869",
    x1: 12.8865,
    y1: 1.90813,
    x2: 16.2458,
    y2: 7.72664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6573_1869",
    x1: 2.6873,
    y1: 1.90813,
    x2: 6.04662,
    y2: 7.72664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6573_1869",
    x1: 2.6873,
    y1: 12.1083,
    x2: 6.04662,
    y2: 17.9268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6573_1869",
    x1: 12.8865,
    y1: 12.1083,
    x2: 16.2458,
    y2: 17.9268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.b5bfb287d153000908b6f293d3907957.svg";
export { ForwardRef as ReactComponent };